// extracted by mini-css-extract-plugin
export default {"about-container":"aboutUs_about-container__Sk9Cp","title-container":"aboutUs_title-container__OO8P1","text-container":"aboutUs_text-container__ivo71"};